export default __webpack_public_path__ + "static/media/PPI-pools-028.80b2a3c2.jpg";